import * as React from "react";
const AddressProofIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={26}
    height={21}
    viewBox="0 0 26 21"
    {...props}
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_988"
          data-name="Rectangle 988"
          width={26}
          height={21}
          transform="translate(0.065 -0.096)"
          fill="currentColor"
        />
      </clipPath>
    </defs>
    <g
      id="Group_5077"
      data-name="Group 5077"
      transform="translate(-0.065 0.096)"
      clipPath="url(#clip-path)"
    >
      <path
        id="Path_1508"
        data-name="Path 1508"
        d="M13.093,14.371A7.188,7.188,0,0,1,20.25,7.839a7.611,7.611,0,0,1,1.066.078L12.636.286A1.356,1.356,0,0,0,11.779,0a1.178,1.178,0,0,0-.9.327L.408,9.452a1.327,1.327,0,0,0-.408.98,1.293,1.293,0,0,0,1.306,1.311H2.613v2.846a1.031,1.031,0,0,0,0,.114v4.573a1.633,1.633,0,0,0,1.633,1.633H4.9c.049,0,.1,0,.147-.008s.122.008.184.008H7.508a1.633,1.633,0,0,0,1.633-1.633V15.682a1.305,1.305,0,0,1,1.306-1.306h2.642Z"
        fill="currentColor"
      />
      <path
        id="Path_1509"
        data-name="Path 1509"
        d="M18.8,8.442a.941.941,0,0,0-1.008-.418l-1.353.311a.941.941,0,0,1-.421,0l-1.353-.311a.941.941,0,0,0-1.008.418l-.738,1.177a.944.944,0,0,1-.3.3l-1.177.738a.941.941,0,0,0-.418,1.007l.311,1.355a.937.937,0,0,1,0,.421l-.311,1.354a.941.941,0,0,0,.418,1.008l1.177.738a.944.944,0,0,1,.3.3l.738,1.177a.941.941,0,0,0,1.008.418l1.353-.311a.941.941,0,0,1,.421,0l1.354.311A.941.941,0,0,0,18.8,18.01l.738-1.177a.934.934,0,0,1,.3-.3l1.178-.738a.941.941,0,0,0,.417-1.008l-.31-1.353a.94.94,0,0,1,0-.421l.311-1.354a.941.941,0,0,0-.417-1.008l-1.178-.738a.941.941,0,0,1-.3-.3Zm-.379,3.106a.376.376,0,0,0-.647-.383L15.8,14.5l-1.188-1.138a.376.376,0,1,0-.52.543l1.531,1.467a.376.376,0,0,0,.584-.08Z"
        transform="translate(3.371 2.452)"
        fill="currentColor"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
export default AddressProofIcon;
